import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import { useAuthStore } from './stores/auth';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'dashboard',
    component: () => import('./views/Dashboard.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/page/:slug',
    name: 'page-edit',
    component: () => import('./views/PageEdit.vue'),
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: '/page/:slug/history',
    name: 'page-history',
    component: () => import('./views/PageHistory.vue'),
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: '/publish',
    name: 'publish',
    component: () => import('./views/PublishDialog.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/publish/:tag(.*)',
    name: 'publish-progress',
    component: () => import('./views/PublishProgress.vue'),
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: '/history',
    name: 'history',
    component: () => import('./views/History.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('./views/Settings.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/oauth/callback',
    name: 'oauth-callback',
    component: () => import('./views/OAuthCallback.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
];

export const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_CMS_BASE_PATH || '/'),
  routes,
});

router.beforeEach((to) => {
  const auth = useAuthStore();
  auth.hydrate();
  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    auth.startLogin(to.fullPath);
    return false;
  }
  return true;
});
